<template>
  <div class="safe-report body">
    <el-container>
      <!-- <ExpenseAside /> -->
      <el-main>
        <el-row type="flex" class="safe-report-filter" :gutter="10">
          <el-col :xl="6" :lg="6" :md="10">
            <div class="bg-White mt-sm-2 p-sm-3">
              <h6 class="mb-1">تصنيف المشروع</h6>

              <el-select
                style="width: 100%"
                v-model="category_id"
                placeholder="حدد الوصف"
                @change="getExpensesReport"
              >
                <el-option
                  v-for="item in categories"
                  :key="item.id"
                  :label="item.description"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="10">
            <div class="bg-White mt-sm-2 p-sm-3">
              <h6 class="mb-1">اسم المشروع</h6>
              <el-select
                style="width: 100%"
                @change="getExpensesReport()"
                v-model="projectId"
                placeholder="اختر المشروع"
              >
                <el-option :value="isNull">عرض الكل</el-option>

                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8">
            <div class="bg-White mt-sm-2 p-sm-3">
              <h6 class="mb-1">حدد الفتره</h6>

              <el-date-picker
                style="width: 100%"
                @change="getExpensesReport"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
                class="display-mobile-none"
              />
              <el-date-picker
                type="date"
                class="filter-mobile"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                @change="getExpensesReport"
                v-model="startDate"
                placeholder="بداية الفترة"
              />
              <el-date-picker
                type="date"
                class="filter-mobile"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                @change="getExpensesReport"
                v-model="endDate"
                placeholder="نهاية الفترة"
              />
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="4" :sm="12">
            <div class="bg-White mt-2 p-sm-3">
              <h6 class="mb-1">اجمالي المصروفات</h6>
              <br class="display-mobile-none" />
              <b> {{ totalExpenses }}</b>
            </div>
          </el-col>

          <el-col :lg="2" :md="4" :sm="12">
            <div class="bg-White result" style="height: 100%">
              <el-button
                type="success"
                @click="sendToPrintAll(tableData)"
                icon="el-icon-printer"
              ></el-button>
            </div>
          </el-col>
        </el-row>

        <el-table
          class="mt-2 table-mobile"
          style="width: 100%"
          align="center"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <el-table-column
            label="#"
            type="index"
            width="50"
            class-name="display-mobile-none"
          />

          <el-table-column
            width="200"
            label="المصروف"
            prop="category.description"
          >
            <template slot-scope="scope">
              <span class="label"> {{ scope.$index + 1 }} # المصروف</span>
              <div>{{ scope.row.category.description }}</div>
            </template>
          </el-table-column>
          <el-table-column label="المبلغ" prop="cost">
            <template slot-scope="scope">
              <span class="label">المبلغ</span>
              <div>{{ scope.row.cost }}</div>
            </template>
          </el-table-column>
          <el-table-column width="160" label="بواسطة" prop="user.name">
            <template slot-scope="scope">
              <span class="label">بواسطة</span>
              <div>{{ scope.row.user.name }}</div>
            </template>
          </el-table-column>

          <el-table-column width="200" label="المشروع" prop="project.name">
            <template slot-scope="scope">
              <span class="label">المشروع</span>
              <div>{{ scope.row.project && scope.row.project.name }}</div>
            </template>
          </el-table-column>
          <el-table-column width="200" label="تعليق" prop="comment">
            <template slot-scope="scope">
              <span class="label">تعليق</span>
              <div>{{ scope.row.comment }}</div>
            </template>
          </el-table-column>
          <el-table-column width="200" label="التوقيت" prop="created_at">
            <template slot-scope="scope">
              <span class="label">التوقيت</span>
              <div>
                {{ scope.row.created_at | moment("Do / MM / YYYY | h:mm A") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" label="الاجراء">
            <template slot-scope="scope">
              <el-row>
                <el-button
                  v-if="accessLinks('delete_expense')"
                  type="primary"
                  icon="el-icon-edit"
                  title="تعديل"
                  size="mini"
                  class="mr-2"
                  @click.native.prevent="editItem(scope)"
                >
                  تعديل
                </el-button>
                <!-- <el-popconfirm
                  v-if="accessLinks('update_expense')"
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد مسح المصروف؟"
                  @confirm="deleteItem(scope)"
                >
                  <div slot="reference">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      title="مسح"
                      size="mini"
                      circle
                    ></el-button>
                  </div>
                </el-popconfirm> -->
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :fullscreen="true"
          title="تعديل بيانات المصروف"
          :visible.sync="editFormVisible"
          v-if="selectedExpenses"
        >
          <el-form :model="selectedExpenses">
            <el-row :gutter="10">
              <el-col :xl="3" :lg="3" :md="6" :sm="12">
                <el-form-item label="المبلغ">
                  <el-input
                    type="number"
                    @focus="$event.target.select()"
                    v-model="selectedExpenses.cost"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" :md="6" :sm="12">
                <el-form-item label="التعليق ">
                  <input
                    class="form-control"
                    v-model="selectedExpenses.comment"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  />
                </el-form-item>
              </el-col>
              <el-col :xl="3" :lg="3" :md="6" :sm="12">
                <el-form-item label="المستلم ">
                  <el-input
                    v-model="selectedExpenses.for_who"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="update">حفظ التعديلات</el-button>
            <el-button class="mr-3" @click="editFormVisible = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ExpenseAside from "@/components/ExpenseAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "ExpensesReportDetails",
  // components: { ExpenseAside },
  data() {
    return {
      isNull: null,
      projectId: null,
      projects: [],
      false: false,
      true: true,
      categories: [],
      editFormVisible: false,
      selectedExpenses: null,
      category_id: null,
      dateRange: null,
      totalExpenses: 0,
      tableData: [],
      startDate: "",
      endDate: "",
    };
  },

  created() {
    if (this.$route.query.category) {
      this.category_id = Number(this.$route.query.category);
    }

    if (this.$route.query.start_date && this.$route.query.end_date) {
      if (window.innerWidth < 575) {
        this.startDate = this.$route.query.start_date;
        this.endDate = this.$route.query.end_date;
      } else {
        this.dateRange = [
          this.$route.query.start_date,
          this.$route.query.end_date,
        ];
      }
    }

    this.getExpensesReport();
    this.getCategories();
    this.getProjects();
  },
  methods: {
    getProjects() {
      axiosApi.get("/projects").then((res) => {
        this.projects = res.data;
      });
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getCategories() {
      axiosApi
        .get("categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    sendToPrintAll() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: tableData,
      //   type: "Expenses",
      //   dateRange: this.dateRange,
      //   title: "Details",
      // };
      // ipcRenderer.send("printing", data);
    },
    getExpensesReport() {
      if (
        (this.dateRange != null || this.startDate || this.endDate) &&
        this.category_id
      ) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let url = `categories/expenses/${this.category_id}`;
        if (this.dateRange != null) {
          url += `/${this.dateRange[0]}`;
          url += `/${this.dateRange[1]}`;
        }
        if (this.startDate) {
          url += `/${this.startDate}`;
        }
        if (this.endDate) {
          url += `/${this.endDate}`;
        }
        if (this.projectId != null) {
          url += `?projectId=${this.projectId}`;
        }
        this.totalExpenses = 0;
        const vm = this;
        axiosApi
          .get(url)
          .then((response) => {
            this.tableData = response.data;

            this.tableData.map(function (value) {
              vm.totalExpenses += +value["cost"];
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    deleteItem(scope) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`expenses/${scope.row.id}`)
        .then(() => {
          this.getExpensesReport();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم مسح بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
      console.log("delete", scope.row);
    },
    editItem(scope) {
      this.selectedExpenses = scope.row;
      this.editFormVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.selectedExpenses.cost = parseFloat(this.selectedExpenses.cost);
      axiosApi
        .put(`expenses/${this.selectedExpenses.id}`, this.selectedExpenses)
        .then(() => {
          this.getExpensesReport();
          this.editFormVisible = false;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم تحديث بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          if (e.response.status == 403) {
            this.$notify.error({
              title: "حدث خطأ",
              message: ` عفوا المبلغ غير متوفر . الخزينه بها فقط  ${e.response.data.balance}`,
              duration: 1500,
            });
          } else {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المطلوبة",
              duration: 1500,
            });
          }
        })
        .finally(() => loading.close());
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
